var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBrokenLink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 256,
    height: 256
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 0,
    strokeMiterlimit: 10,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M127.857 254.307c-69.725 0-126.45-56.726-126.45-126.45 0-69.725 56.725-126.45 126.45-126.45 69.724 0 126.45 56.725 126.45 126.45 0 69.724-56.726 126.45-126.45 126.45z",
    fill: "#3cc65c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.402 196.887a19.032 19.032 0 01-13.547-5.612l-15.23-15.23c-7.47-7.469-7.47-19.622 0-27.094l44.381-44.378c7.469-7.472 19.622-7.472 27.094 0l3.642 3.642a8.432 8.432 0 01-11.926 11.923l-3.639-3.642a2.307 2.307 0 00-3.25 0l-44.38 44.378a2.307 2.307 0 000 3.251l15.23 15.23a2.253 2.253 0 001.625.672 2.25 2.25 0 001.624-.672l12.558-12.56a8.429 8.429 0 0111.923 0 8.426 8.426 0 010 11.92l-12.558 12.56a19.022 19.022 0 01-13.547 5.612z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.54 156.74c-4.906 0-9.81-1.865-13.544-5.597l-3.642-3.645a8.426 8.426 0 010-11.92 8.426 8.426 0 0111.92 0l3.642 3.642a2.304 2.304 0 003.251 0l44.378-44.38a2.253 2.253 0 00.672-1.625 2.25 2.25 0 00-.672-1.624l-15.23-15.233a2.304 2.304 0 00-3.25 0l-12.562 12.558a8.43 8.43 0 01-11.92-11.923l12.561-12.558c7.466-7.466 19.62-7.47 27.094 0l15.23 15.233a19.022 19.022 0 015.612 13.547c0 5.117-1.992 9.928-5.612 13.547l-44.384 44.378c-3.731 3.735-8.638 5.6-13.544 5.6z",
    fill: "#fff"
  }))));
}
export default __webpack_public_path__ + "media/icons/broken-link-cb2d288d.svg";
export { SvgBrokenLink as ReactComponent };